import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle
} from '@mui/material';

interface RemoveCommonDialogProps extends DialogProps {
  onRemove: () => void;
  title: string;
  isLoading?: boolean;
}
export const RemoveCommonDialog = ({ onRemove, title, open, isLoading, onClose }: RemoveCommonDialogProps) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        Opravdu chcete smazat tento záznam? Tento krok nelze vzít zpět.
      </DialogContentText>
    </DialogContent>
    <DialogActions
      sx={{
        py: 4,
        justifyContent: 'center',
        flexDirection: { xs: 'column-reverse', md: 'row' },
        gap: 2
      }}
    >
      <Button onClick={() => onClose?.({}, 'backdropClick')}>Zavřít</Button>
      <Button autoFocus variant="contained" color="error" onClick={onRemove} loading={isLoading}>
        Smazat záznam
      </Button>
    </DialogActions>
  </Dialog>
);
